import { Affix, Button, Card } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../../../apiServices/common";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddSalesContactForm from "./AddSalesContactForm";

export default function UpdateSalesContact(props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Props
  const { width, isAmend, isEdit } = props;

  // States
  const [permitInfo, setPermitInfo] = useState();

  // Router
  let { styleId } = useParams();

  // Others
  const propertyFormRef = useRef(null);
  const edit_url = `/api/sales_contract/${styleId}/edit`;

  const addProduct = () => {
    propertyFormRef.current.submit();
  };

  const getPIInfo = async () => {
    let res = await getData(edit_url);

    if (res) {
      let masterData = res.data.data;
      setPermitInfo(masterData);
    }
  };

  useEffect(() => {
    getPIInfo();
  }, []);

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={`${isAmend ? "Amend" : "Update"} Sales Contact`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addProduct()}
                loading={isSubmitting}
              >
                {`${isAmend ? "Amend" : "Update"} Sales Contact`}
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AddSalesContactForm
        permitInfo={permitInfo}
        ref={propertyFormRef}
        isAmend={isAmend}
        isEdit={isEdit}
        setIsSubmitting={setIsSubmitting}
      />
    </>
  );
}
